const cases = [
  {
    tag: "E-commerce",
    title: "Power your online store",
    desc: "Accept all major payment methods, handle subscriptions, and reduce cart abandonment with one-click checkout.",
    icon: "ri-shopping-bag-line",
    color: "#2563EB",
    bg: "linear-gradient(135deg, #EFF6FF, #DBEAFE)",
    image: "/products/usecase_ecommerce.png",
    link: "/products/payments",
  },
  {
    tag: "SaaS & Platforms",
    title: "Monetize your platform",
    desc: "Build marketplace payments, revenue sharing, and automated onboarding with Paygent Connect.",
    icon: "ri-building-4-line",
    color: "#14B8A6",
    bg: "linear-gradient(135deg, #F0FDFA, #CCFBF1)",
    image: "/products/usecase_saas.png",
    link: "/products/subscriptions",
  },
  {
    tag: "Enterprise",
    title: "Scale without limits",
    desc: "Enterprise-grade security, compliance, and dedicated support for large-scale payment operations.",
    icon: "ri-building-line",
    color: "#8B5CF6",
    bg: "linear-gradient(135deg, #F5F3FF, #EDE9FE)",
    image: "/products/usecase_enterprise.png",
    hoverClass: "group-hover:animate-[mapPan_10s_ease-in-out_infinite]",
    link: "/resources/case-studies",
  },
];

export default function UseCasesSection() {
  return (
    <section className="py-16 md:py-24" style={{ background: "#F5F7FB" }}>
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="text-center mb-12">
          <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full text-xs font-semibold bg-blue-50 text-blue-600 border border-blue-100 mb-4 tracking-wide">
            USE CASES
          </div>
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">Built for every business model</h2>
          <p className="text-lg text-gray-500 max-w-xl mx-auto">Whether you&apos;re a startup or Fortune 500, Paygent scales with you.</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {cases.map((c) => (
            <div
              key={c.tag}
              className="bg-white rounded-2xl border border-gray-100 overflow-hidden hover:shadow-lg transition-all duration-300 hover:-translate-y-1 cursor-pointer group"
              style={{ boxShadow: "0 2px 12px rgba(0,0,0,0.05)" }}
            >
              <div className="h-44 overflow-hidden">
                <img
                  src={c.image}
                  alt={c.title}
                  className={`w-full h-full object-cover object-top transition-transform duration-500 transform ${c.hoverClass || 'group-hover:scale-105'}`}
                  style={c.tag === "Enterprise" ? { transformOrigin: 'center center' } : {}}
                />
              </div>
              <div className="p-6">
                <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full text-xs font-semibold mb-3"
                  style={{ background: c.bg, color: c.color }}>
                  <div className="w-3.5 h-3.5 flex items-center justify-center">
                    <i className={`${c.icon} text-xs`} />
                  </div>
                  {c.tag}
                </div>
                <h3 className="text-xl font-bold text-gray-900 mb-2">{c.title}</h3>
                <p className="text-sm text-gray-500 leading-relaxed mb-4">{c.desc}</p>
                <a href={c.link} className="inline-flex items-center gap-1 text-sm font-semibold transition-colors cursor-pointer" style={{ color: c.color }}>
                  Learn more <i className="ri-arrow-right-line w-4 h-4 flex items-center justify-center" />
                </a>
              </div>
            </div>
          ))}
        </div>
      </div>

      <style>{`
        @keyframes mapPan {
          0% { transform: scale(1.3) translateX(0) translateY(0); }
          50% { transform: scale(1.3) translateX(-8%) translateY(3%); }
          100% { transform: scale(1.3) translateX(0) translateY(0); }
        }
      `}</style>
    </section>
  );
}
